import { useEffect, useState } from "react"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import CtaSection from "../components/CtaSection"

import heroBg from "../assets/hero-bg.png"
import fuelControlImg from "../assets/fuel-control.png"
import fuelAutomationVideo from "../assets/fuel-automation-video.mp4"
import fuelWhyImg from "../assets/tracksmart.jpg"
import fuelCardImg from "../assets/fuel-card.png"
import fuelSolutionImg from "../assets/petrol.png"
import fuelSaferImg from "../assets/fuelSafer.png"
import fuelDashboardImg from "../assets/fuel-dashboard.png"

import theft from "../assets/theft.png"
import inventry from "../assets/inventry-control.webp"
import realfuel from "../assets/realfuel.webp"

import Reveal from "../components/Reveal"

import mobile from "../assets/Mobile.png"
import bowser from "../assets/Bowser.png"
import tank from "../assets/Tank.jpg"
import bowserauto from "../assets/Bowser-Automation.png"
import staticDispensing from "../assets/Static.png"
import daytank from "../assets/Day-Tank.png"
import staticautomation from "../assets/Static-Automation.avif"

import staticdu from "../assets/Static-DU.png"
import mobiletankers from "../assets/mobile-tankers.jpg"
import barrel from "../assets/barrel.webp"
import silencer from "../assets/silencer.webp"

import phone1 from "../assets/phone1.png"
import phone2 from "../assets/phone2.png"
import phone3 from "../assets/phone3.png"
import phone4 from "../assets/phone4.png"

import report1 from "../assets/report1.png"
import report2 from "../assets/report2.png"

import fuelMonitoring1 from "../assets/fuelmonitoring1.png"
import fuelMonitoring2 from "../assets/fuelmonitoring2.png"
import fuelMonitoring3 from "../assets/fuelmonitoring3.png"
import fuelMonitoring4 from "../assets/fuelmonitoring4.png"
import fuelMonitoring5 from "../assets/fuelmonitoring5.png"
import fuelMonitoring6 from "../assets/fuelmonitoring6.webp"

const containerClass =
  "mx-auto w-full max-w-[1500px] px-5 sm:px-8 lg:px-12 xl:px-20"

const whyChooseCards = [
  {
    title: "Inventory Control",
    text: "Monitor tank level, density & temperature with high-accuracy ATG.",
    imageAlt: "Inventory Control",
    image: inventry,
  },
  {
    title: "Theft Prevention",
    text: "Alerts on anomalies, decantation losses, and unauthorized refueling.",
    imageAlt: "Theft Prevention",
    image: theft,
  },
  {
    title: "Real-Time Dispensing",
    text: "RFID-enabled vehicle ID, OTP/smart tag authorization & automated dispensing.",
    imageAlt: "Real-Time Dispensing",
    image: realfuel,
  },
]

const fuelSolutionItems = [
  {
    tab: "Mobile Dispensing Unit",
    title: "Mobile Dispensing Unit",
    image: mobile,
    imageAlt: "Mobile Dispensing Unit",
    description:
      "The FEM-M series mobile models are designed specifically for construction and mining sites, offering an effective fuel management solution. These units are essential for ensuring reliable and efficient fuel operations in demanding industrial conditions.",
    features: [
      "IoT-Integrated Real-Time Monitoring",
      "Model: FEM-M-DC, Series: FEM-M",
      "Built-in Data Logger, High Flow Rate",
      "Explosion-Proof Design, Ideal For Construction And Mining Sites",
    ],
  },
  {
    tab: "Bowser Dispensing Unit",
    title: "Bowser Dispensing Unit",
    image: bowser,
    imageAlt: "Bowser Dispensing Unit",
    description:
      "Our Bowser Dispensing Units provide versatile and mobile fuel management solutions for various industries. Designed for flexibility and durability, these units ensure accurate dispensing in any environment.",
    features: [
      "Advanced Flow Control Technology",
      "Wireless Connectivity Options",
      "Customizable Tank Capacity",
      "All-Weather Design With Reinforced Structure",
    ],
  },
  {
    tab: "Tank Gauging",
    title: "Tank Gauging",
    image: tank,
    imageAlt: "Tank Gauging",
    description:
      "Our precision tank gauging systems provide real-time monitoring and accurate measurement of fuel levels. These systems help minimize fuel loss and optimize inventory management through advanced sensing technology.",
    features: [
      "Continuous Level Monitoring",
      "Temperature Compensation",
      "Leak Detection Capabilities",
      "Cloud-Based Reporting System",
    ],
  },
  {
    tab: "Bowser Automation",
    title: "Bowser Automation",
    image: bowserauto,
    imageAlt: "Bowser Automation",
    description:
      "Transform your fuel management with our intelligent bowser automation solutions. Our systems integrate seamlessly with existing infrastructure to provide automated dispensing, monitoring, and reporting features.",
    features: [
      "Automated Dispensing Controls",
      "User Authentication System",
      "Predictive Maintenance Alerts",
      "Integration With Fleet Management Software",
    ],
  },
  {
    tab: "Static Dispensing Unit",
    title: "Static Dispensing Unit",
    image: staticDispensing,
    imageAlt: "Static Dispensing Unit",
    description:
      "Our static dispensing units provide permanent, high-capacity fuel management solutions for facilities with consistent fuel requirements. Built for longevity and reliability, these units form the backbone of industrial fuel operations.",
    features: [
      "High-Volume Pumping Capability",
      "Multi-User Access Control",
      "Industrial-Grade Construction",
      "Comprehensive Audit Trail System",
    ],
  },
  {
    tab: "Day Tank",
    title: "Day Tank",
    image: daytank,
    imageAlt: "Day Tank",
    description:
      "Our day tank systems provide a reliable buffer for critical operations, ensuring continuous fuel supply to generators and equipment. Engineered for safety and efficiency, these tanks feature advanced monitoring and automated refill capabilities.",
    features: [
      "Automatic Pump Control System",
      "Overflow Protection",
      "Remote Monitoring Capability",
      "Customizable Alert Thresholds",
    ],
  },
  {
    tab: "Static Automation",
    title: "Static Automation",
    image: staticautomation,
    imageAlt: "Static Automation",
    description:
      "Our static automation solutions transform conventional fuel management into intelligent, self-monitoring systems. These comprehensive solutions provide enterprise-level control and visibility across your entire fuel infrastructure.",
    features: [
      "Centralized Management Dashboard",
      "Automated Reconciliation System",
      "Advanced Analytics And Reporting",
      "Scalable Architecture For Growing Operations",
    ],
  },
]

const scrollToAbout = () => {
  document
    .getElementById("about-ais140")
    ?.scrollIntoView({ behavior: "smooth" });
};

const smartSolutionItems = [
  {
    title: "Static DU Automation",
    verticalTitle: "Static DU Automation",
    image: staticdu,
    imageAlt: "Static DU Automation",
    description: "Hardware kit for IOCL/HPCL DUs",
    features: [
      "Real-time fuel monitoring",
      "Automatic transaction processing",
      "RFID card integration",
      "Web-based control panel",
      "Inventory management system",
    ],
  },
  {
    title: "Bowser Automation",
    verticalTitle: "Bowser Automation",
    image: mobiletankers,
    imageAlt: "Bowser Automation",
    description:
      "Mobile tankers integrated with nozzle readers, RFID, and vehicle tags.",
    features: [
      "Portable and lightweight design",
      "DC power operation",
      "RFID card authentication",
      "Built-in filtration system",
      "Precise metering capabilities",
    ],
  },
  {
    title: "Barrel Dispensers",
    verticalTitle: "Barrel Dispensers",
    image: barrel,
    imageAlt: "Barrel Dispensers",
    description:
      "DC-powered portable units with RFID + built-in filters and meters.",
    features: [
      "Mobile tanker integration",
      "Smart nozzle readers",
      "Vehicle tracking & monitoring",
      "RFID vehicle identification",
      "Real-time location tracking",
    ],
  },
  // {
  //   title: "ATG",
  //   verticalTitle: "ATG",
  //   image: silencer,
  //   imageAlt: "ATG",
  //   description:
  //     "Automated tank gauging system with real-time inventory and web portal sync.",
  //   features: [
  //     "Mobile tanker integration",
  //     "Smart nozzle readers",
  //     "Vehicle tracking & monitoring",
  //     "RFID vehicle identification",
  //     "Real-time location tracking",
  //   ],
  // },
]

const SyncIcon = () => (
  <svg className="h-9 w-9 text-white" viewBox="0 0 24 24" fill="none">
    <path
      d="M20 12a8 8 0 0 1-14.8 4.2M4 12A8 8 0 0 1 18.8 7.8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5 17H2v-3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M19 7h3v3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)


const InventoryIndustryIcon = () => (
  <svg viewBox="0 0 64 64" className="h-8 w-8" fill="none">
    <path d="M12 22 32 12l20 10-20 10-20-10Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
    <path d="M12 22v20l20 10V32L12 22Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
    <path d="M52 22v20L32 52V32l20-10Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
    <path d="M24 16l20 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
)

const LogisticsIndustryIcon = () => (
  <svg viewBox="0 0 64 64" className="h-8 w-8" fill="none">
    <path d="M10 20h30v24H10V20Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
    <path d="M40 29h9l6 8v7H40V29Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
    <circle cx="22" cy="48" r="5" stroke="currentColor" strokeWidth="4" />
    <circle cx="48" cy="48" r="5" stroke="currentColor" strokeWidth="4" />
    <path d="M24 28h8M28 24v8" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
)

const SchoolIndustryIcon = () => (
  <svg viewBox="0 0 64 64" className="h-8 w-8" fill="none">
    <path d="M10 24h44v20H10V24Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
    <path d="M16 18h32l6 6H10l6-6Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
    <path d="M18 31h8M32 31h8M46 31h4" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <circle cx="20" cy="48" r="5" stroke="currentColor" strokeWidth="4" />
    <circle cx="46" cy="48" r="5" stroke="currentColor" strokeWidth="4" />
  </svg>
)

const AgricultureConstructionIndustryIcon = () => (
  <svg viewBox="0 0 64 64" className="h-8 w-8" fill="none">
    <path d="M16 38h24l8-13h6" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M24 38V24h12l4 14" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
    <circle cx="22" cy="46" r="8" stroke="currentColor" strokeWidth="4" />
    <circle cx="46" cy="46" r="5" stroke="currentColor" strokeWidth="4" />
    <path d="M12 20c8 0 12-4 16-10 4 6 8 10 16 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
)

const OilGasMiningIndustryIcon = () => (
  <svg viewBox="0 0 64 64" className="h-8 w-8" fill="none">
    <path d="M32 8s14 16 14 30a14 14 0 0 1-28 0C18 24 32 8 32 8Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round" />
    <path d="M25 40c1 5 4 8 9 8" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M10 54h44" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
  </svg>
)


const ReportIcon = () => (
  <div className="flex h-[58px] w-[58px] items-center justify-center rounded-full border border-gray-100 bg-white shadow-[0_8px_22px_rgba(0,0,0,0.16)]">
    <div className="flex items-end gap-[4px]">
      <span className="block h-[16px] w-[7px] rounded-sm bg-[#ed860f]" />
      <span className="block h-[26px] w-[7px] rounded-sm bg-[#ed860f]" />
      <span className="block h-[20px] w-[7px] rounded-sm bg-[#ed860f]" />
    </div>
  </div>
)

const InstallSpeedIcon = () => (
  <svg viewBox="0 0 64 64" className="h-12 w-12" fill="none">
    <path
      d="M12 42a20 20 0 1 1 40 0"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M32 42 43 27"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <circle cx="32" cy="42" r="4" fill="currentColor" />
    <path
      d="M18 42h5M41 42h5M22 28l4 4M32 22v6M42 28l-4 4"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
)

const MileageIcon = () => (
  <svg viewBox="0 0 64 64" className="h-9 w-9" fill="none">
    <path
      d="M12 40a20 20 0 1 1 40 0"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M32 40 43 27"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <circle cx="32" cy="40" r="4" fill="currentColor" />
    <path
      d="M18 40h4M42 40h4M22 26l3 3M32 20v5M42 26l-3 3"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
)

const ConsumptionIcon = () => (
  <svg viewBox="0 0 64 64" className="h-9 w-9" fill="none">
    <path
      d="M18 10h22a4 4 0 0 1 4 4v40H18V10Z"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinejoin="round"
    />
    <path
      d="M25 18h12v12H25V18Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M44 20h5v10c0 6 7 6 7 14 0 5-3 9-7 9-5 0-8-4-8-10"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M14 54h34"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
)

const ConsolidatedReportIcon = () => (
  <svg viewBox="0 0 64 64" className="h-9 w-9" fill="none">
    <rect
      x="12"
      y="10"
      width="40"
      height="44"
      rx="4"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      d="M20 22h24M20 32h24M20 42h24"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M28 18v30M38 18v30"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M46 46l6 6"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <circle
      cx="43"
      cy="43"
      r="7"
      stroke="currentColor"
      strokeWidth="4"
    />
  </svg>
)


const IndustryLoopIcon = () => (
  <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none">
    <path
      d="M17.5 7.5A7 7 0 0 0 5.2 9.8"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="M15.5 7.5h2.8V4.7"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 16.5a7 7 0 0 0 12.3-2.3"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="M8.5 16.5H5.7v2.8"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const DrainTankIcon = () => (
  <svg viewBox="0 0 120 90" className="h-20 w-20" fill="none">
    <rect x="12" y="34" width="72" height="32" rx="3" stroke="currentColor" strokeWidth="6" />
    <path d="M84 44h16l10 13v9H84V44Z" stroke="currentColor" strokeWidth="6" />
    <path d="M20 40v22M30 40v22M40 40v22M50 40v22M60 40v22M70 40v22" stroke="currentColor" strokeWidth="4" />
    <circle cx="28" cy="72" r="7" stroke="currentColor" strokeWidth="5" />
    <circle cx="96" cy="72" r="7" stroke="currentColor" strokeWidth="5" />
  </svg>
)

const FuelPumpIcon = () => (
  <svg viewBox="0 0 100 110" className="h-20 w-20" fill="none">
    <rect x="22" y="10" width="48" height="78" rx="6" stroke="currentColor" strokeWidth="6" />
    <rect x="31" y="20" width="30" height="25" stroke="currentColor" strokeWidth="5" />
    <path d="M70 26h8v18c0 10 13 11 13 25 0 9-6 15-13 15-8 0-13-7-13-16" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
    <path d="M14 92h66" stroke="currentColor" strokeWidth="7" strokeLinecap="round" />
  </svg>
)

const BillIcon = () => (
  <svg viewBox="0 0 100 110" className="h-20 w-20" fill="none">
    <path d="M20 8h45l17 17v75H20V8Z" stroke="currentColor" strokeWidth="6" strokeLinejoin="round" />
    <path d="M65 8v19h17" stroke="currentColor" strokeWidth="6" strokeLinejoin="round" />
    <path d="M32 31h20M32 48h38M32 63h38M32 78h28" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    <rect x="32" y="40" width="15" height="15" stroke="currentColor" strokeWidth="5" />
  </svg>
)

const OdometerIcon = () => (
  <svg viewBox="0 0 120 90" className="h-20 w-20" fill="none">
    <path d="M22 70a38 38 0 0 1 76 0" stroke="currentColor" strokeWidth="13" strokeLinecap="butt" strokeDasharray="13 8" />
    <path d="M60 64 40 45" stroke="currentColor" strokeWidth="7" strokeLinecap="round" />
    <circle cx="60" cy="64" r="7" fill="currentColor" />
  </svg>
)

const fuelTheftTypes = [
  {
    title: "Drain fuel directly from tank",
    text: "Drivers drain remaining fuel after trip completion and sell it for extra money.",
    icon: DrainTankIcon,
  },
  {
    title: "Stealing from returning line",
    text: "A T-fitting is added on the fuel returning line, so fuel meant to return to the tank gets collected.",
    icon: FuelPumpIcon,
  },
  {
    title: "Manipulation of invoices and bills",
    text: "Drivers fill less diesel but collect invoices for higher liters to claim extra reimbursement.",
    icon: BillIcon,
  },
  {
    title: "Odometer reprogramming",
    text: "Odometer readings are changed to hide actual kilometers and justify false fuel consumption.",
    icon: OdometerIcon,
  },
]


const industriesCovered = [
  {
    title: "Inventory Control",
    text: "Ambulance services, emergency service provider, 108 ambulance service and reefer trucks",
    active: true,
    Icon: InventoryIndustryIcon,
  },
  {
    title: "Logistics & Cold Chain",
    text: "Fleet owners, truck operators, 3PL, e-commerce, cold-chain operators and manufactures",
    Icon: LogisticsIndustryIcon,
  },
  {
    title: "School and Colleges",
    text: "Fleet of school buses and college buses",
    Icon: SchoolIndustryIcon,
  },
  {
    title: "Agriculture & Construction",
    text: "General construction sector, highway contract companies and agriculture machineries owners",
    Icon: AgricultureConstructionIndustryIcon,
  },
  {
    title: "Oil, Gas & Mining",
    text: "Tankers supplying oil and gas, mining industries vehicles with 24/7 operations",
    Icon: OilGasMiningIndustryIcon,
  },
]

export default function Section3() {
  const [activeFuelIndex, setActiveFuelIndex] = useState(0)
  const [activeSmartIndex, setActiveSmartIndex] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveFuelIndex((current) => (current + 1) % fuelSolutionItems.length)
    }, 3000)

    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveSmartIndex((current) => (current + 1) % smartSolutionItems.length)
    }, 3000)

    return () => clearInterval(intervalId)
  }, [])

  const activeFuelSolution = fuelSolutionItems[activeFuelIndex]

  const getSmartIndex = (offset) =>
    (activeSmartIndex + offset + smartSolutionItems.length) %
    smartSolutionItems.length

  const activeSmartSolution = smartSolutionItems[activeSmartIndex]
  const previousSmartSolution = smartSolutionItems[getSmartIndex(-1)]
  const nextSmartSolutions = [
    smartSolutionItems[getSmartIndex(1)],
    smartSolutionItems[getSmartIndex(2)],
  ]

  return (
    <>
      {/* Hero */}
      <section className="relative mx-auto w-full max-w-[calc(100%-24px)] overflow-hidden rounded-b-[42px] bg-black sm:max-w-[calc(100%-32px)] lg:max-w-[calc(100%-48px)]">
        <Navbar />

        <div
          className="relative min-h-[520px] bg-cover bg-center sm:min-h-[600px] lg:min-h-[680px]"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="absolute inset-0 bg-black/65" />

          <div className="relative z-10 flex min-h-[520px] items-center justify-center px-5 pt-24 text-center sm:min-h-[600px] lg:min-h-[680px]">
            <div className="mx-auto max-w-[900px]">
              <h1 className="text-[34px] font-bold leading-tight text-white sm:text-5xl lg:text-[60px]">
                Fuel Automation
              </h1>

              <div className="mx-auto mt-3 h-[3px] w-[220px] rounded-full bg-[#ed860f] sm:w-[360px]" />

              <p className="mx-auto mt-7 max-w-[760px] text-sm leading-relaxed text-white/75 sm:text-base">
                Enhance your fuel management with smart automation, real-time
                tracking, powerful analytics, and secure fuel control.
              </p>

              <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
                <button
                  onClick={scrollToAbout}
                  className="inline-flex min-w-[210px] items-center justify-center rounded-md bg-[#ed860f] px-8 py-4 text-sm font-medium text-white transition hover:bg-[#d9780d]"
                >
                  Get This Solution
                </button>

                <a
                  href="/contact"
                  className="inline-flex min-w-[210px] items-center justify-center rounded-md border border-white px-8 py-4 text-sm font-medium text-white transition hover:bg-white hover:text-black"
                >
                  Contact us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Committed Control */}
      <section
        id="about-ais140"
        className="bg-white py-14 sm:py-16 lg:py-20">
        <div className="mx-auto w-full max-w-[1180px] px-5 sm:px-8">
          <div className="mb-10 text-center">
            <h2 className="text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
              Committed to Real-Time Control
            </h2>

            <p className="mt-3 text-sm text-gray-600">
              Fuel Automation That Goes Beyond Tracking
            </p>
          </div>

          <div className="grid items-center gap-10 lg:grid-cols-[1fr_0.95fr]">
            <div>
              <p className="mb-7 max-w-[620px] text-sm leading-relaxed text-gray-700 sm:text-[15px]">
                See how our FuelEye platform empowers businesses to monitor,
                manage, and secure every drop of fuel — in real time.
              </p>

              <div className="space-y-4">
                {[
                  "Live tank inventory with level, density, and temperature tracking",
                  "RFID-tagged vehicle authentication before every fuel dispense",
                  "Digital logs, alerts, and analytics — all accessible anytime",
                  "Seamless ERP integration and multi-site visibility",
                ].map((point, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-[52px_1fr] items-center gap-4 border-b border-[#ed860f] pb-3"
                  >
                    <span className="text-[28px] font-bold leading-none text-transparent [-webkit-text-stroke:1px_#ed860f]">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <p className="text-sm font-semibold leading-relaxed text-black sm:text-[15px]">
                      {point}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative overflow-hidden rounded-xl bg-black">
              <video
                className="h-[300px] w-full object-cover sm:h-[360px] lg:h-[390px]"
                poster={fuelControlImg}
                controls
                playsInline
                preload="metadata"
              >
                <source src={fuelAutomationVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </section>


      {/* Major Types Of Fuel Theft */}
      <section className="relative overflow-hidden bg-white py-14 sm:py-16 lg:py-20">
        <div className="absolute left-0 top-16 h-64 w-64 rounded-full bg-[#ed860f]/10 blur-3xl" />
        <div className="absolute bottom-8 right-0 h-72 w-72 rounded-full bg-black/5 blur-3xl" />

        <div className="relative mx-auto w-full max-w-[1280px] px-5 sm:px-8">
          <div className="mb-10 text-center">
            <p className="mb-3 text-sm font-bold uppercase tracking-[0.28em] text-[#ed860f]">
              Risk Patterns
            </p>

            <h2 className="text-4xl font-black tracking-tight text-black sm:text-5xl lg:text-[56px]">
              4 Major Types Of Fuel Theft
            </h2>

            <p className="mx-auto mt-4 max-w-[720px] text-sm font-medium leading-relaxed text-gray-600 sm:text-[15px]">
              Fuel theft is not always obvious. These are the common leakage
              points where businesses silently lose money.
            </p>
          </div>

          <div className="grid gap-6 lg:grid-cols-2">
            {fuelTheftTypes.map((item, index) => {
              const TheftIcon = item.icon

              return (
                <article
                  key={item.title}
                  className="group relative min-h-[190px] overflow-hidden rounded-2xl border border-[#ed860f]/45 bg-white p-6 shadow-[0_14px_40px_rgba(0,0,0,0.06)] transition-all duration-500 hover:-translate-y-2 hover:border-[#ed860f] hover:bg-[#111111] hover:shadow-[0_24px_70px_rgba(237,134,15,0.24)] sm:p-7"
                >
                  <div className="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-[#ed860f]/0 transition-all duration-500 group-hover:bg-[#ed860f]/20" />

                  <div className="absolute bottom-5 right-6 text-[72px] font-black leading-none text-black/[0.035] transition-all duration-500 group-hover:text-white/[0.06]">
                    {String(index + 1).padStart(2, "0")}
                  </div>

                  <div className="grid items-center gap-6 sm:grid-cols-[120px_1fr]">
                    <div className="relative flex h-[120px] w-[120px] shrink-0 items-center justify-center">
                      {/* Default animated state */}
                      <div className="absolute inset-0 flex items-center justify-center rounded-3xl border border-[#ed860f]/25 bg-gradient-to-br from-[#fff7ef] via-white to-[#fff0dd] transition-all duration-500 group-hover:scale-75 group-hover:rotate-6 group-hover:opacity-0">
                        <div className="absolute h-[86px] w-[86px] rounded-full border border-[#ed860f]/20" />
                        <div className="absolute h-[62px] w-[62px] rounded-full border border-[#ed860f]/30" />
                        <div className="absolute h-[38px] w-[38px] animate-ping rounded-full bg-[#ed860f]/20" />

                        <div className="relative z-10 flex h-[46px] w-[46px] items-center justify-center rounded-full bg-[#ed860f] text-sm font-black text-white shadow-[0_10px_24px_rgba(237,134,15,0.35)]">
                          {String(index + 1).padStart(2, "0")}
                        </div>


                      </div>

                      {/* Hover icon state */}
                      <div className="absolute inset-0 flex scale-75 rotate-[-10deg] items-center justify-center rounded-3xl bg-[#fff4e8] text-[#ed860f] opacity-0 shadow-[0_16px_36px_rgba(237,134,15,0.25)] transition-all duration-500 group-hover:scale-100 group-hover:rotate-0 group-hover:opacity-100">
                        <TheftIcon />
                      </div>
                    </div>

                    <div className="relative z-10">
                      <div className="mb-4 inline-flex rounded-full bg-[#ed860f]/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] text-[#ed860f] transition-all duration-500 group-hover:bg-white/10 group-hover:text-white">
                        Theft Type {index + 1}
                      </div>

                      <h3 className="text-xl font-black leading-tight text-black transition-colors duration-500 group-hover:text-white sm:text-2xl">
                        {item.title}
                      </h3>

                      <p className="mt-4 max-w-[520px] text-sm font-medium leading-relaxed text-gray-600 transition-colors duration-500 group-hover:text-white/75 sm:text-[15px]">
                        {item.text}
                      </p>
                    </div>
                  </div>
                </article>
              )
            })}
          </div>
        </div>
      </section>

      {/* Real Time Reporting Dashboard */}
      <section className="bg-white py-14 sm:py-16 lg:py-20">
        <div className="mx-auto w-full max-w-[1180px] px-5 sm:px-8">
          <div className="mb-8 text-center">
            <h2 className="text-3xl font-bold tracking-tight text-black sm:text-4xl lg:text-[38px]">
              Real Time Reporting Dashboard
            </h2>

            <p className="mx-auto mt-3 max-w-[760px] text-sm font-medium leading-relaxed text-gray-500">
              Monitor fuel fills, detect theft instantly, and optimize fleet
              performance with real-time intelligence.
            </p>
          </div>

          <div className="space-y-7">
            {/* Row 1 */}
            <div className="relative overflow-hidden rounded-xl bg-white">
              <div className="absolute inset-y-0 left-0 hidden w-1/2 bg-[#F8DAB7] lg:block" />
              <div className="absolute inset-y-0 right-0 hidden w-1/2 bg-[#BFE2F6] lg:block" />

              <div className="relative grid min-h-[360px] items-center gap-6 rounded-xl bg-gradient-to-r from-[#F8DAB7] to-[#BFE2F6] px-6 py-8 sm:px-8 lg:grid-cols-[1fr_230px_72px_230px_1fr] lg:gap-4 lg:px-10 lg:py-5">
                <div className="max-w-[250px]">
                  <h3 className="text-xl font-bold leading-tight text-black">
                    Fuel Filled Report
                  </h3>

                  <p className="mt-5 text-sm font-medium leading-relaxed text-gray-700">
                    Track every drop accurately. Veyonta Fuel Level Sensor
                    System delivers 99.5% precise reports, detailing when and
                    where fuel is filled in your trucks.
                  </p>
                </div>

                <div className="flex justify-center">
                  <img
                    src={phone2}
                    alt="Fuel filled report"
                    className="h-[285px] w-auto object-contain sm:h-[330px] lg:h-[345px]"
                  />
                </div>

                <div className="relative hidden h-[280px] items-center justify-center lg:flex">
                  <div className="absolute left-1/2 top-0 h-full -translate-x-1/2 border-l-2 border-dotted border-white/90" />
                  <div className="relative z-10">
                    <ReportIcon />
                  </div>
                </div>

                <div className="flex justify-center">
                  <img
                    src={phone1}
                    alt="Fuel theft report"
                    className="h-[285px] w-auto object-contain sm:h-[330px] lg:h-[345px]"
                  />
                </div>

                <div className="max-w-[260px] lg:justify-self-end">
                  <h3 className="text-xl font-bold leading-tight text-black">
                    Fuel Theft Report
                  </h3>

                  <p className="mt-5 text-sm font-medium leading-relaxed text-gray-700">
                    Safeguard profitability. With Veyonta Fuel Monitoring,
                    receive real-time reports on attempted fuel theft, showing
                    exact liters, time, and location.
                  </p>
                </div>
              </div>
            </div>

            {/* Row 2 */}
            <div className="relative overflow-hidden rounded-xl bg-white">
              <div className="absolute inset-y-0 left-0 hidden w-1/2 bg-[#F8DAB7] lg:block" />
              <div className="absolute inset-y-0 right-0 hidden w-1/2 bg-[#BFE2F6] lg:block" />

              <div className="relative grid min-h-[360px] items-center gap-6 rounded-xl bg-gradient-to-r from-[#F8DAB7] to-[#BFE2F6] px-6 py-8 sm:px-8 lg:grid-cols-[1fr_230px_72px_230px_1fr] lg:gap-4 lg:px-10 lg:py-5">
                <div className="max-w-[250px]">
                  <h3 className="text-xl font-bold leading-tight text-black">
                    Fuel Graphical Report
                  </h3>

                  <p className="mt-5 text-sm font-medium leading-relaxed text-gray-700">
                    Visual representation of fuel usage helps fleet managers to
                    identify anomalies and monitor consumption patterns easily.
                  </p>
                </div>

                <div className="flex justify-center">
                  <img
                    src={phone3}
                    alt="Fuel graphical report"
                    className="h-[285px] w-auto object-contain sm:h-[330px] lg:h-[345px]"
                  />
                </div>

                <div className="relative hidden h-[280px] items-center justify-center lg:flex">
                  <div className="absolute left-1/2 top-0 h-full -translate-x-1/2 border-l-2 border-dotted border-white/90" />
                  <div className="relative z-10">
                    <ReportIcon />
                  </div>
                </div>

                <div className="flex justify-center">
                  <img
                    src={phone4}
                    alt="Instant alerts anywhere"
                    className="h-[285px] w-auto object-contain sm:h-[330px] lg:h-[345px]"
                  />
                </div>

                <div className="max-w-[260px] lg:justify-self-end">
                  <h3 className="text-xl font-bold leading-tight text-black">
                    Instant Alerts, Anywhere
                  </h3>

                  <p className="mt-5 text-sm font-medium leading-relaxed text-gray-700">
                    Safeguard profitability. With BlackBox Fuel Monitoring,
                    receive real-time reports on attempted fuel theft, showing
                    exact liters, time, and location.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Advanced Fuel Reports */}
      <section className="relative overflow-hidden bg-white py-14 sm:py-16 lg:py-20">
        <div className="absolute left-0 top-20 h-64 w-64 rounded-full bg-[#ed860f]/10 blur-3xl" />
        <div className="absolute bottom-10 right-0 h-72 w-72 rounded-full bg-black/5 blur-3xl" />

        <div className="relative mx-auto w-full max-w-[1280px] px-5 sm:px-8">
          <div className="mb-10 text-center">
            <p className="mb-3 text-sm font-bold uppercase tracking-[0.28em] text-[#ed860f]">
              Smart Reports
            </p>

            <h2 className="text-3xl font-black tracking-tight text-black sm:text-4xl lg:text-[48px]">
              Fuel Performance Reports
            </h2>

            <p className="mx-auto mt-4 max-w-[760px] text-sm font-medium leading-relaxed text-gray-600 sm:text-[15px]">
              Get clean insights into mileage, fuel consumption, and consolidated
              fleet performance without wasting time in manual spreadsheets.
            </p>
          </div>

          <div className="grid items-center gap-10 lg:grid-cols-[0.95fr_1.05fr]">
            <div className="space-y-7">
              {[
                {
                  title: "Mileage Report",
                  text: "Clear insights about the system that includes a comprehensive analysis of your vehicle’s performance by comparing the distance traveled with fuel consumed.",
                  Icon: MileageIcon,
                },
                {
                  title: "Consumption Report",
                  text: "Access fuel consumption data across all fleet vehicles on a daily as well as monthly basis, which helps in improving overall operational efficiency.",
                  Icon: ConsumptionIcon,
                },
                {
                  title: "Consolidated Reports",
                  text: "Effortlessly access daily and monthly fuel consumption reports for each vehicle in one glance, aligned with distance covered.",
                  Icon: ConsolidatedReportIcon,
                },
              ].map((item, index) => {
                const Icon = item.Icon

                return (
                  <article
                    key={item.title}
                    className="group grid items-center gap-5 rounded-2xl border border-transparent bg-white p-4 transition-all duration-500 hover:-translate-y-1 hover:border-[#ed860f]/35 hover:shadow-[0_20px_55px_rgba(0,0,0,0.08)] sm:grid-cols-[92px_1fr] sm:p-5"
                  >
                    <div className="relative flex h-[92px] w-[92px] items-center justify-center rounded-xl bg-[#FDEDDC] text-[#ed860f] transition-all duration-500 group-hover:scale-105 group-hover:bg-[#ed860f] group-hover:text-white group-hover:shadow-[0_16px_34px_rgba(237,134,15,0.28)]">
                      <div className="absolute inset-0 rounded-xl border border-[#ed860f]/20 transition-all duration-500 group-hover:scale-110 group-hover:opacity-0" />
                      <Icon />
                    </div>

                    <div>
                      <div className="mb-2 inline-flex rounded-full bg-[#ed860f]/10 px-3 py-1 text-[11px] font-black uppercase tracking-[0.18em] text-[#ed860f] opacity-0 transition-all duration-500 group-hover:opacity-100">
                        Report {index + 1}
                      </div>

                      <h3 className="text-xl font-black leading-tight text-black sm:text-2xl">
                        {item.title}
                      </h3>

                      <p className="mt-3 max-w-[560px] text-sm font-medium leading-relaxed text-gray-600">
                        {item.text}
                      </p>
                    </div>
                  </article>
                )
              })}
            </div>

            <div className="relative min-h-[430px]">
              <div className="absolute -right-4 top-0 hidden h-44 w-44 rounded-full bg-[#ed860f]/10 blur-3xl lg:block" />

              <div className="relative ml-auto w-full max-w-[620px]">
                <div className="group rounded-2xl border border-gray-200 bg-white p-3 shadow-[0_18px_50px_rgba(0,0,0,0.08)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_28px_80px_rgba(237,134,15,0.18)]">
                  <img
                    src={report1}
                    alt="Mileage and consumption report table"
                    className="h-auto w-full rounded-xl object-contain"
                  />
                </div>

                <div className="mt-8 w-full max-w-[430px] rounded-2xl border border-gray-200 bg-white p-3 shadow-[0_18px_50px_rgba(0,0,0,0.08)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_28px_80px_rgba(237,134,15,0.18)] lg:ml-10">
                  <img
                    src={report2}
                    alt="Consolidated fuel report table"
                    className="h-auto w-full rounded-xl object-contain"
                  />
                </div>


              </div>
            </div>
          </div>
        </div>
      </section>


            {/* Fuel Monitoring Installation Vehicles */}
      <section className="relative overflow-hidden bg-white py-14 sm:py-16 lg:py-20">
        <div className="absolute left-0 top-20 h-64 w-64 rounded-full bg-[#ed860f]/10 blur-3xl" />
        <div className="absolute bottom-10 right-0 h-72 w-72 rounded-full bg-black/5 blur-3xl" />

        <div className="relative mx-auto w-full max-w-[1280px] px-5 sm:px-8">
          <div className="mb-10 text-center">
            <p className="mb-3 text-sm font-bold uppercase tracking-[0.28em] text-[#ed860f]">
              Easy Installation
            </p>

            <h2 className="text-3xl font-black tracking-tight text-black sm:text-4xl lg:text-[46px]">
              Fuel Monitoring System can be installed in
            </h2>

            <p className="mx-auto mt-4 max-w-[780px] text-sm font-medium leading-relaxed text-gray-600 sm:text-[15px]">
              Our fuel monitoring solution is designed for trucks, buses,
              construction equipment, agricultural machinery, generators, and
              specialized fleet vehicles.
            </p>
          </div>

        <div className="relative mx-auto min-h-[720px] max-w-[1120px] lg:min-h-[560px]">
  {/* Connection lines - exact desktop style */}
  {/* Connection lines - desktop */}
<div className="pointer-events-none absolute inset-0 z-10 hidden lg:block">
  {/* lines only */}
  <svg
    className="absolute inset-0 h-full w-full"
    viewBox="0 0 1120 560"
    fill="none"
    preserveAspectRatio="none"
  >
    {/* top left */}
    <path
      d="M288 105 H335 L415 180"
      stroke="#ed860f"
      strokeOpacity="0.55"
      strokeWidth="2"
    />

    {/* top right */}
    <path
      d="M705 180 L785 105 H832"
      stroke="#ed860f"
      strokeOpacity="0.55"
      strokeWidth="2"
    />

    {/* bottom left */}
    <path
      d="M260 350 H315 L415 270"
      stroke="#ed860f"
      strokeOpacity="0.55"
      strokeWidth="2"
    />

    {/* bottom right */}
    <path
      d="M705 270 L805 350 H860"
      stroke="#ed860f"
      strokeOpacity="0.55"
      strokeWidth="2"
    />
  </svg>

  {/* dots above cards */}
  <span className="absolute left-[25.7%] top-[18.8%] z-30 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#ed860f]" />
  <span className="absolute right-[25.7%] top-[18.8%] z-30 h-4 w-4 translate-x-1/2 -translate-y-1/2 rounded-full bg-[#ed860f]" />
  <span className="absolute left-[23.2%] top-[62.5%] z-30 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#ed860f]" />
  <span className="absolute right-[23.2%] top-[62.5%] z-30 h-4 w-4 translate-x-1/2 -translate-y-1/2 rounded-full bg-[#ed860f]" />
</div>
  {/* Center vehicle */}
  <div className="absolute left-1/2 top-[42%] z-20 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center lg:top-[43%]">
    <div className="relative flex h-[205px] w-[205px] items-center justify-center rounded-full border border-[#ed860f]/55 bg-[#fff6ed] shadow-[0_22px_70px_rgba(237,134,15,0.16)]">
      <div className="absolute h-[150px] w-[150px] rounded-full bg-[#ed860f]/10" />
      <div className="absolute h-[105px] w-[105px] animate-pulse rounded-full bg-[#ed860f]/10" />

      <img
        src={fuelMonitoring6}
        alt="Specialized fleet vehicle"
        className="relative z-10 max-h-[145px] w-[205px] object-contain drop-shadow-xl transition-transform duration-500 hover:scale-110"
      />
    </div>

    <h3 className="mt-4 text-xl font-black text-black">
      Specialized Fleet
    </h3>
  </div>

  {/* Vehicles */}
  <div className="grid gap-6 pt-[270px] sm:grid-cols-2 lg:block lg:pt-0">
    <article className="group relative rounded-2xl bg-white p-4 text-center shadow-[0_16px_45px_rgba(0,0,0,0.06)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_70px_rgba(237,134,15,0.18)] lg:absolute lg:left-[2%] lg:top-[4%] lg:w-[235px] lg:shadow-none">
      <img
        src={fuelMonitoring1}
        alt="Bus"
        className="mx-auto h-[110px] w-full object-contain transition-transform duration-500 group-hover:scale-110"
      />
      <h3 className="mt-3 text-xl font-black text-black">Bus</h3>
    </article>

    <article className="group relative rounded-2xl bg-white p-4 text-center shadow-[0_16px_45px_rgba(0,0,0,0.06)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_70px_rgba(237,134,15,0.18)] lg:absolute lg:right-[1%] lg:top-[4%] lg:w-[275px] lg:shadow-none">
      <img
        src={fuelMonitoring2}
        alt="Agriculture vehicles"
        className="mx-auto h-[115px] w-full object-contain transition-transform duration-500 group-hover:scale-110"
      />
      <h3 className="mt-3 text-xl font-black text-black">
        Agriculture vehicles
      </h3>
    </article>

    <article className="group relative rounded-2xl bg-white p-4 text-center shadow-[0_16px_45px_rgba(0,0,0,0.06)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_70px_rgba(237,134,15,0.18)] lg:absolute lg:left-[-3%] lg:top-[43%] lg:w-[270px] lg:shadow-none">
      <img
        src={fuelMonitoring5}
        alt="Truck"
        className="mx-auto h-[125px] w-full object-contain transition-transform duration-500 group-hover:scale-110"
      />
      <h3 className="mt-3 text-xl font-black text-black">Truck</h3>
    </article>

    <article className="group relative rounded-2xl bg-white p-4 text-center shadow-[0_16px_45px_rgba(0,0,0,0.06)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_70px_rgba(237,134,15,0.18)] lg:absolute lg:right-[-2%] lg:top-[43%] lg:w-[280px] lg:shadow-none">
      <img
        src={fuelMonitoring4}
        alt="Diesel gensets"
        className="mx-auto h-[120px] w-full object-contain transition-transform duration-500 group-hover:scale-110"
      />
      <h3 className="mt-3 text-xl font-black text-black">
        Diesel Gensets, etc.
      </h3>
    </article>

    <article className="group relative rounded-2xl bg-white p-4 text-center shadow-[0_16px_45px_rgba(0,0,0,0.06)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_70px_rgba(237,134,15,0.18)] sm:col-span-2 lg:absolute lg:bottom-[-2%] lg:left-1/2 lg:w-[300px] lg:-translate-x-1/2 lg:shadow-none lg:hover:-translate-x-1/2 lg:hover:-translate-y-2">
      <img
        src={fuelMonitoring3}
        alt="Construction vehicle"
        className="mx-auto h-[135px] w-full object-contain transition-transform duration-500 group-hover:scale-110"
      />
      <h3 className="mt-3 text-xl font-black text-black">
        Construction vehicle
      </h3>
    </article>
  </div>
</div>

          {/* Installation CTA */}
          <div className="mx-auto mt-8 grid max-w-[1120px] overflow-hidden rounded-xl bg-[#ed860f] shadow-[0_24px_70px_rgba(237,134,15,0.22)] lg:grid-cols-[210px_1fr_1.35fr]">
            <div className="flex items-center justify-center bg-white/12 p-7 text-white">
              <div className="flex h-[110px] w-[110px] items-center justify-center rounded-xl bg-white/15">
                <InstallSpeedIcon />
              </div>
            </div>

            <div className="flex items-center px-7 py-8">
              <h3 className="text-2xl font-black leading-tight text-white">
                Installation in under <br /> 2 hours
              </h3>
            </div>

            <div className="relative flex items-center px-7 py-8 text-white">
              <span className="absolute left-5 top-4 text-6xl font-black leading-none text-white/70">
                “
              </span>

              <p className="relative z-10 max-w-[560px] pl-8 text-sm font-semibold leading-relaxed text-white/90">
                We provide a smooth installation process. Complete installation
                can take up to 2 hours only.
              </p>

              <span className="absolute bottom-3 right-8 text-6xl font-black leading-none text-white/70">
                ”
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose */}
      <section className="bg-white py-12 sm:py-14 lg:py-16">
        <div className={containerClass}>
          <div className="mb-10 text-center">
            <h2 className="text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
              Why Choose{" "}
              <span className="inline-block bg-[#ed860f] px-2 py-1 text-white">
                VEYONTA TRACK
              </span>{" "}
              Fuel Management?
            </h2>
          </div>

          <div className="mx-auto grid max-w-[1280px] gap-6 lg:grid-cols-3">
            {whyChooseCards.map((card, index) => (
              <article
                key={card.title}
                className="flex flex-col overflow-hidden rounded-xl bg-[#ed860f] p-2.5 shadow-xl transition-transform duration-300 hover:-translate-y-1 sm:p-3"
              >
                <div className="w-full">
                  <img
                    src={card.image}
                    alt={card.imageAlt}
                    className="h-[220px] w-full rounded-lg object-cover sm:h-[260px] lg:h-[230px]"
                  />
                </div>

                <div className="flex flex-1 items-center px-6 py-7 text-white sm:px-8">
                  <div>
                    <SyncIcon />

                    <div className="mt-5 inline-flex rounded-full bg-white/15 px-3 py-1 text-sm font-bold text-white">
                      {String(index + 1).padStart(2, "0")}
                    </div>

                    <h3 className="mt-5 text-2xl font-bold lg:text-[24px]">
                      {card.title}
                    </h3>

                    <p className="mt-4 text-sm leading-relaxed text-white/90 sm:text-[15px]">
                      {card.text}
                    </p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>



      {/* Industries Covered */}
      <section className="relative overflow-hidden bg-white py-14 sm:py-16 lg:py-20">
        <div className="absolute left-0 top-12 h-64 w-64 rounded-full bg-[#ed860f]/10 blur-3xl" />
        <div className="absolute bottom-10 right-0 h-72 w-72 rounded-full bg-black/5 blur-3xl" />

        <div className="relative mx-auto w-full max-w-[1180px] px-5 sm:px-8">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-black tracking-tight text-black sm:text-4xl lg:text-[42px]">
              Industries covered by Veyonta
            </h2>

            <p className="mx-auto mt-4 max-w-[720px] text-sm font-medium leading-relaxed text-gray-600 sm:text-[15px]">
              From healthcare and logistics to construction and energy, our
              solutions help organizations gain complete control over fuel
              operations.
            </p>
          </div>

          <div className="grid gap-7 lg:grid-cols-3">
            {industriesCovered.slice(0, 3).map((item) => (
              <article
                key={item.title}
                className="group relative flex min-h-[220px] flex-col items-center justify-center overflow-hidden rounded-xl border border-gray-200 bg-white p-7 text-center text-black shadow-[0_16px_40px_rgba(0,0,0,0.08)] transition-all duration-500 hover:-translate-y-2 hover:border-[#ed860f] hover:bg-[#ed860f] hover:text-white hover:shadow-[0_24px_70px_rgba(237,134,15,0.28)]"
              >
                <div className="mb-6 flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[#FDEDDC] text-[#ed860f] transition-all duration-500 group-hover:scale-110 group-hover:bg-white/20 group-hover:text-white">
                  <item.Icon />
                </div>

                <h3 className="text-2xl font-black leading-tight text-black transition-colors duration-500 group-hover:text-white">
                  {item.title}
                </h3>

                <p className="mt-4 max-w-[285px] text-sm font-semibold leading-relaxed text-gray-600 transition-colors duration-500 group-hover:text-white/85">
                  {item.text}
                </p>
              </article>
            ))}
          </div>

          <div className="mt-7 grid gap-7 lg:grid-cols-2">
            {industriesCovered.slice(3).map((item) => (
              <article
                key={item.title}
                className="group relative flex min-h-[220px] flex-col items-center justify-center overflow-hidden rounded-xl border border-gray-200 bg-white p-7 text-center text-black shadow-[0_16px_40px_rgba(0,0,0,0.08)] transition-all duration-500 hover:-translate-y-2 hover:border-[#ed860f] hover:bg-[#ed860f] hover:text-white hover:shadow-[0_24px_70px_rgba(237,134,15,0.28)]"
              >
                <div className="mb-6 flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[#FDEDDC] text-[#ed860f] transition-all duration-500 group-hover:scale-110 group-hover:bg-white/20 group-hover:text-white">
                  <item.Icon />
                </div>

                <h3 className="text-2xl font-black leading-tight text-black transition-colors duration-500 group-hover:text-white">
                  {item.title}
                </h3>

                <p className="mt-4 max-w-[420px] text-sm font-semibold leading-relaxed text-gray-600 transition-colors duration-500 group-hover:text-white/85">
                  {item.text}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Integrated Infrastructure */}
      <section className="relative overflow-hidden bg-white py-10 sm:py-12 lg:py-14">
        <img
          src={fuelCardImg}
          alt=""
          className="absolute left-[-10px] top-1/2 hidden w-24 -translate-y-1/2 rotate-[-18deg] opacity-90 lg:block xl:left-[2%] xl:w-32"
        />

        <img
          src={fuelCardImg}
          alt=""
          className="absolute right-[-10px] top-1/2 hidden w-24 -translate-y-1/2 rotate-[18deg] opacity-90 lg:block xl:right-[2%] xl:w-32"
        />

        <div className={containerClass}>
          <div className="mx-auto max-w-[980px] text-center">
            <h2 className="mx-auto max-w-[780px] text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-[38px]">
              Fully Integrated Fuel Infrastructure Automation
            </h2>

            <p className="mx-auto mt-5 max-w-[900px] text-sm leading-relaxed text-gray-600 sm:text-[15px]">
              Veyonta Track is engineered for reliability and customization.
              Whether you’re operating fuel storage tanks, bowsers, or static
              dispensers, our cloud-connected platform ensures seamless data
              flow from hardware to dashboard. It supports ATG probes and mini
              consoles for underground and aboveground tanks, static pump and
              bowser automation with RFID/OTP authentication, built-in data
              loggers, USB/PC interfaces, ERP integration, digital calibration
              with W&M approval, role-based access control, audit trails, and
              secure user management.
            </p>

            <p className="mx-auto mt-4 max-w-[900px] text-sm leading-relaxed text-gray-400">
              With integrated sensors and automation tools, organizations can
              improve visibility, reduce losses, and gain complete transparency
              across every fuel transaction.
            </p>
          </div>
        </div>
      </section>

      {/* Smart Solutions */}
      <section className="bg-white py-14 sm:py-16 lg:py-20">
        <div className="mx-auto w-full max-w-[1450px] px-5 sm:px-8">
          <Reveal animation="fade-up">
            <div className="mb-10 text-center">
              <h2 className="text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
                Fuel Automation Solutions
              </h2>

              <p className="mx-auto mt-3 max-w-[820px] text-sm leading-relaxed text-gray-600 sm:text-[15px]">
                Advanced technology for modern fuel management systems
              </p>
            </div>
          </Reveal>

          <div className="mx-auto mt-6 max-w-[1200px]">
            {/* Top row: up to 3 cards */}
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              {smartSolutionItems.slice(0, 3).map((item, index) => (
                <article
                  key={item.title}
                  className="group relative overflow-hidden rounded-2xl shadow-lg bg-cover bg-center h-[260px] md:h-[340px]"
                  style={{ backgroundImage: `url(${item.image})` }}
                >
                  <div className="absolute inset-0 bg-black/30 transition-colors duration-300 group-hover:bg-black/45" />

                  <div className="absolute inset-0 flex items-end p-6">
                    <div className="transform-gpu transition-all duration-300 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 text-white">
                      <div className="inline-flex items-center gap-3 rounded-full bg-white/10 px-3 py-1 text-sm font-semibold">
                        <span className="text-sm font-bold">{String(index + 1).padStart(2, '0')}</span>
                      </div>
                      <h3 className="mt-2 text-lg font-bold">{item.title}</h3>
                      <p className="mt-2 max-w-[420px] text-sm leading-relaxed text-white/90">{item.description}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            {/* Bottom row: center any remaining card(s) */}
            {smartSolutionItems.length > 3 && (
              <div className="mt-8 flex justify-center">
                {smartSolutionItems.slice(3).map((item, idx) => (
                  <article
                    key={item.title}
                    className="group w-full max-w-[520px] overflow-hidden rounded-2xl shadow-lg bg-cover bg-center h-[420px] md:h-[480px]"
                    style={{ backgroundImage: `url(${item.image})` }}
                  >
                    <div className="absolute inset-0 bg-black/30 transition-colors duration-300 group-hover:bg-black/45" />
                    <div className="absolute inset-0 flex items-end justify-center p-6">
                      <div className="transform-gpu transition-all duration-300 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 text-center text-white">
                        <div className="text-xs opacity-80">{String(4 + idx).padStart(2, '0')}</div>
                        <h3 className="mt-2 text-2xl font-bold">{item.title}</h3>
                        <p className="mt-3 text-sm leading-relaxed text-white/90 max-w-[440px] mx-auto">{item.description}</p>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Fuel Automation Solutions */}
      <section className="bg-white py-14 sm:py-16 lg:py-20">
        <div className="mx-auto w-full max-w-[1450px] px-5 sm:px-8">
          <div className="mb-7">
            <h2 className="text-3xl font-bold text-black sm:text-4xl lg:text-[38px]">
              Our Products & Solutions
            </h2>

            {/* <p className="mt-3 text-sm text-gray-600">
              Advanced technology for modern fuel management systems
            </p> */}
          </div>

          <div className="mb-9 flex gap-1 overflow-x-auto rounded-md bg-[#ed860f] p-1 lg:overflow-visible">
            {fuelSolutionItems.map((item, index) => (
              <button
                key={item.tab}
                type="button"
                onClick={() => setActiveFuelIndex(index)}
                className={`min-w-max flex-1 rounded-md px-3 py-3 text-xs font-medium transition sm:text-sm xl:px-4 ${index === activeFuelIndex
                  ? "bg-white text-[#ed860f]"
                  : "bg-[#ed860f] text-white hover:bg-[#d9780d]"
                  }`}
              >
                {item.tab}
              </button>
            ))}
          </div>

          <div
            key={activeFuelSolution.title}
            className="grid overflow-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition-all duration-500 ease-out sm:p-6 lg:grid-cols-[1.1fr_1fr] lg:gap-10"
          >
            <div className="overflow-hidden rounded-lg bg-[#eef4f8]">
              <img
                src={activeFuelSolution.image}
                alt={activeFuelSolution.imageAlt}
                className="h-[260px] w-full object-contain sm:h-[330px] lg:h-[360px]"
              />
            </div>

            <div className="mt-8 flex items-center lg:mt-0">
              <div>
                <h3 className="text-2xl font-bold text-black">
                  {activeFuelSolution.title}
                </h3>

                <p className="mt-4 max-w-[620px] text-sm leading-relaxed text-gray-700 sm:text-[15px]">
                  {activeFuelSolution.description}
                </p>

                <h4 className="mt-7 text-xl font-bold text-black">
                  Features
                </h4>

                <ul className="mt-5 space-y-4">
                  {activeFuelSolution.features.map((feature) => (
                    <li key={feature} className="flex items-start gap-3">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#ed860f]" />
                      <span className="text-sm font-medium leading-relaxed text-black">
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Track Smarter Fuel Safer */}
      <section className="bg-white py-14 sm:py-16 lg:py-20">
        <div className="mx-auto w-full max-w-[1200px] px-5 sm:px-8">
          <div className="mb-10 text-center">
            <h2 className="text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
              Track Smarter Fuel Safer
            </h2>

            <p className="mx-auto mt-3 max-w-[760px] text-sm leading-relaxed text-gray-600">
              Improve safety and transparency with smart fuel control hardware
              and real-time alerts.
            </p>
          </div>

          <div className="grid items-stretch gap-10 lg:grid-cols-[0.9fr_1fr]">
            <div className="flex min-h-[320px] items-center rounded-xl border-[8px] border-[#ed860f] p-4 lg:min-h-[360px]">
              <img
                src={fuelSaferImg}
                alt="Fuel safer devices"
                className="h-[260px] w-full rounded-lg object-contain sm:h-[320px]"
              />
            </div>

            <div className="flex min-h-[320px] flex-col justify-center lg:min-h-[360px]">
              <p className="mb-6 max-w-[620px] text-sm leading-relaxed text-gray-600">
                Ensure every drop reaches the right vehicle. Our FMS uses RFID
                tank-mounted tags and wireless nozzle readers for seamless
                identification and dispensing.
              </p>

              <div className="space-y-0">
                {[
                  "Tank-Mounted Passive RFID",
                  "Nozzle Reader with 12-month battery life",
                  "Customizable kit for bowsers and industrial vehicles",
                ].map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-[56px_1fr] items-center gap-4 border-b border-[#ed860f] py-4"
                  >
                    <span className="text-[32px] font-bold leading-none text-transparent [-webkit-text-stroke:1px_#ed860f]">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <p className="text-sm font-semibold leading-relaxed text-black sm:text-[15px]">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Analytics */}
      <section className="bg-white py-14 sm:py-16 lg:py-20">
        <div className="mx-auto w-full max-w-[1250px] px-5 sm:px-8">
          <div className="mb-10 text-center">
            <h2 className="text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
              Powerful Analytics & Alerts
            </h2>

            <p className="mx-auto mt-4 max-w-[980px] text-sm leading-relaxed text-gray-600">
              Our system offers robust analytics and reporting tools, allowing
              you to generate daily, weekly, and fully customized reports. You
              can monitor vehicle-wise fuel consumption with precision and gain
              deeper insights into operational efficiency across all assets.
            </p>
          </div>

          <img
            src={fuelDashboardImg}
            alt="Fuel analytics dashboard"
            className="mx-auto w-full rounded-xl object-cover"
          />
        </div>
      </section>

      <CtaSection />
      <Footer />
    </>
  )
}